// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeedControlPage {
  padding-left: 281px;
  background: #eff0f4;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.FeedControlPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 43px 40px 27px;
  box-sizing: border-box;
}
.FeedControlPage .titleBlock h1 {
  margin: 0;
  font-family: "Montserrat Regular", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #2c274b;
}
.FeedControlPage__content {
  padding: 32px 40px 48px;
  max-width: 1200px;
}
.FeedControlPage__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.FeedControlPage__card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(44, 39, 75, 0.06);
}
.FeedControlPage__detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.FeedControlPage__caption {
  white-space: pre-wrap;
  word-break: break-word;
}
.FeedControlPage__reports {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}
.FeedControlPage__reports h3 {
  margin: 0 0 12px;
  font-size: 16px;
}
.FeedControlPage__reportItem {
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 8px;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/FeedControlPage/FeedControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AACI;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACN;AAGE;EACE,uBAAA;EACA,iBAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAOE;EACE,qBAAA;EACA,sBAAA;AALJ;AAQE;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;AANJ;AAQI;EACE,gBAAA;EACA,eAAA;AANN;AAUE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AARJ","sourcesContent":[".FeedControlPage {\n  padding-left: 281px;\n  background: #eff0f4;\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n\n  .titleBlock {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    padding: 43px 40px 27px;\n    box-sizing: border-box;\n\n    h1 {\n      margin: 0;\n      font-family: 'Montserrat Regular', sans-serif;\n      font-weight: 500;\n      font-size: 24px;\n      color: #2c274b;\n    }\n  }\n\n  &__content {\n    padding: 32px 40px 48px;\n    max-width: 1200px;\n  }\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n\n  &__card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 1px 2px rgba(44, 39, 75, 0.06);\n  }\n\n  &__detail {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__caption {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n\n  &__reports {\n    margin-top: 8px;\n    padding-top: 12px;\n    border-top: 1px solid #f0f0f0;\n\n    h3 {\n      margin: 0 0 12px;\n      font-size: 16px;\n    }\n  }\n\n  &__reportItem {\n    padding: 10px 12px;\n    background: #fafafa;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FeedControlPage": `FeedControlPage`,
	"titleBlock": `titleBlock`,
	"FeedControlPage__content": `FeedControlPage__content`,
	"FeedControlPage__filters": `FeedControlPage__filters`,
	"FeedControlPage__card": `FeedControlPage__card`,
	"FeedControlPage__detail": `FeedControlPage__detail`,
	"FeedControlPage__caption": `FeedControlPage__caption`,
	"FeedControlPage__reports": `FeedControlPage__reports`,
	"FeedControlPage__reportItem": `FeedControlPage__reportItem`
};
export default ___CSS_LOADER_EXPORT___;
